import { render, staticRenderFns } from "./DSAlert.vue?vue&type=template&id=53b1fa0c&scoped=true&"
import script from "./DSAlert.vue?vue&type=script&lang=ts&"
export * from "./DSAlert.vue?vue&type=script&lang=ts&"
import style0 from "./DSAlert.vue?vue&type=style&index=0&id=53b1fa0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1fa0c",
  null
  
)

export default component.exports